export const COLORS = {
  BLACK: "#131313",
  RED: "#FF3056",
  YELLOW: "#FCE07B",
  DARK_BLUE: "#123B51",
  LIGHT_BLUE: "#D6E5EB",
  LIGHT_GREY: "#e0e0e0",
  DARK_GREY: "#858585",
  MEDIUM_GREY: "#bdbdbd",
  GREEN: "#479546",
  LIGHT_GREEN: "#A0E0AF",
  MEDIUM_GREEN: "#00B183",
  FACEBOOK_BLUE: "#3b5998",
  TWITTER_BLUE: "#38A1F3",
}
